import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { parse } from 'date-fns';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from 'src/app/services/common.service';
import { WhatsAppContactGroupService } from 'src/app/services/whats-app-contact-group.service';
import { WhatsappCampaignService } from 'src/app/services/whatsapp-campaign.service';
import { ProductService } from 'src/app/services/product.service';
import { conditionalValidator, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { WhatsappTemplateService } from 'src/app/services/whatsapp-template.service';
import { VendorSettingsService } from 'src/app/services/vendor-settings.service';
import { UsersService } from 'src/app/services/users.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { TIMEZONE_ZONES, TimezoneOption } from 'src/app/shared/utils/timezone-zones.constant';

interface ButtonData {
  buttonIndex: number;
  buttonType: string;
  text?: string;
  phoneNumber?: string;
  url?: string;
  example?: string;
}

interface CustomButtons {
  data: ButtonData[];
  totalButtonsUsed: number;
  totalAllowedButtons: number;
  buttonUsesByTypes: {
    PHONE_NUMBER: number;
    PHONE_NUMBER_LIMIT: number;
    COPY_CODE: number;
    COPY_CODE_LIMIT: number;
    URL_BUTTON: number;
    URL_BUTTON_LIMIT: number;
    // Add other button types as needed
  };
}
@Component({
  selector: 'calsoft-create-campaign-template',
  templateUrl: './create-campaign-template.component.html',
  styleUrls: ['./create-campaign-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateCampaignTemplateComponent implements OnChanges, OnDestroy {

  url = '';
  sanitizedUrl = '';



  @Input() type: any = 1;
  @Input() fromSequence: boolean = false; // Flag to indicate if coming from sequence task
  @Input() sequenceWhatsappTemplateUid: string = ''; // Store template UID from sequence task
  @Input() sequenceTaskId: string = ''; // Store task ID from sequence
  @Input() leadContactsData: Array<{ firstName: string, email: string, phoneNumber: string }> = []; // Lead contacts from sequence
  @Input() task: any;
  @Output() getInputJson: EventEmitter<any> = new EventEmitter<any>();
  @Output() formFieldInvalid: EventEmitter<any> = new EventEmitter<any>();
  templateForm: FormGroup;
  enableHeaderVariableExample = false;
  resourcePrivilege: any;
  uploadedMediaFileName = '';
  bodyVariables: { textVariable: string }[] = [];
  uploadedMediaUrl: string | ArrayBuffer | null = null;
  uploadedMediaType: string | null = null;
  locationName = 'Sample Location';
  address = '123 Main St, City';
  contactGroupList: any;
  mainTemplateData: any;
  headerMediaType: any;
  showMediaUpload: boolean;
  crmSettingsData: any;
  whatsappContactId: any;
  whatsappVendorId: any;
  templateNames: any;
  filteredTemplateNames: any[] = [];
  templateSearchControl: FormControl = new FormControl('', Validators.required);
  templateSearchLoading = false;
  noTemplateSearchResults = false;
  contactGroupSearchControl: FormControl = new FormControl('');
  filteredContactGroups: any[] = [];
  contactGroupSearchLoading = false;
  noContactGroupSearchResults = false;
  selectedContactGroup: any = null;
  init: boolean = false;
  typeYFilterControl: FormControl = new FormControl('');
  statusFilterControl: FormControl = new FormControl('');
  sourceFilterControl: FormControl = new FormControl('');
  userTypeList: any;
  leadStatusList: any[] = [];
  leadSourceList: any[] = [];
  filteredStatusList: any[] = [];
  filteredSourceList: any[] = [];
  leadFilterLoading = false;
  filteredLeadsCount = 0;
  isLeadFilterApplied = false;
  userList: any;
  filtereduserTypeList: any;

  /** Solr search string emitted by calsoft-filter-list-popup for Lead Owner/Status/Source */
  campaignLeadFilterSearchTerm: string = '';

  /** filterSelectObj passed to calsoft-filter-list-popup inside the Lead Filter accordion */
  campaignLeadFilterSelectObj: any[] = [
    {
      name: 'Owner',
      property: 'ownerEmail',
      type: 'multiSelect',
      position: 'firstValue',
      options: [],
      display: true
    },
    {
      name: 'Status Name',
      property: 'statusName',
      type: 'multiSelect',
      position: 'secondValue',
      options: [],
      display: true
    },
    {
      name: 'Source Name',
      property: 'sourceName',
      type: 'multiSelect',
      position: 'thirdValue',
      options: [],
      display: true
    },
    {
      name: 'Created Date',
      property: 'createdDate',
      type: 'date',
      position: 'sixthValue',
      display: true
    },
    {
      name: 'Updated Date',
      property: 'updatedDate',
      type: 'date',
      position: 'seventhValue',
      display: true
    }
  ];

  //For Dynamic Template Section
  showLocationFields = false;
  locationExamples = {
    latitude: '21.170240',
    longitude: '72.831062',
    name: 'Surat',
    address: 'Gujarat'
  };
  selectedTemplate: any;
  parsedData: any;
  isTemplateSelected: boolean;
  showListofTemplates: boolean = false;
  vendorSettingsData: any;
  currentPhoneNUmber: any;
  currentPhoneNumberID: any;
  text: string = "Schedule Campaign";
  today: Date = new Date();
  fileNameNew: string;
  leadPhoneNumbers: string[] = []; // Store phone numbers from leads
  fromLeads: boolean = false; // Flag to indicate if coming from leads page

  constructor(private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private vendorSettingsService: VendorSettingsService,
    private whatsAppContactGroupService: WhatsAppContactGroupService,
    private sanitizer: DomSanitizer,
    private WhatsappTemplateService: WhatsappTemplateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private ecryptService: EcryptServiceService,
    private commonService: CommonService,
    private campaignService: WhatsappCampaignService,
    private usersService: UsersService,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private productService: ProductService
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  templateJson =
    {

    };

  ngOnInit(): void {

    this.setupTemplateSearch();
    this.setupContactGroupSearch();
    this.getUserDropDownList();
    this.usertypeYFilter();

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe((res: any) => {
      this.leadStatusList = res || [];
      this.filteredStatusList = this.leadStatusList.slice();
      this.cdRef.markForCheck();
    });
    this.leadSourceService.getAllLeadSourceDropDown().subscribe((res: any) => {
      this.leadSourceList = res || [];
      this.filteredSourceList = this.leadSourceList.slice();
      this.cdRef.markForCheck();
    });

    this.setupStatusFilter();
    this.setupSourceFilter();

    this.activatedRoute.queryParams.subscribe(params => {

      if (params['fromLeads']) {

        this.fromSequence = false;
        this.fromLeads = true;

        let encryptedLeadData = params['lead'] || sessionStorage.getItem('leadContactsData');

        if (encryptedLeadData) {
          try {

            const decryptedLeadData = this.ecryptService.decryptionAES(encryptedLeadData);
            const leadObjects = JSON.parse(decryptedLeadData);

            if (Array.isArray(leadObjects) && leadObjects.length > 0) {

              this.leadContactsData = leadObjects.map((lead: any) => ({
                firstName: lead.name || lead.firstName || '',
                email: lead.email || lead.prospectEmailid || '',
                phoneNumber: lead.phoneNo || lead.phoneNumber || '',
                leadId: lead.entityId || '',
              })).filter((contact: any) => contact.phoneNumber && contact.phoneNumber.trim());


              this.leadPhoneNumbers = this.leadContactsData.map(contact => contact.phoneNumber);
            }

            sessionStorage.removeItem('leadContactsData');
          } catch (err) {

            sessionStorage.removeItem('leadContactsData');
          }
        }


      } else if (this.type == 2) {

        this.fromSequence = true;
        this.fromLeads = false;
        this.sequenceTaskId = this.task['taskId'] || '';
        this.sequenceWhatsappTemplateUid = this.task['whatsappTemplateUid'] || '';

        const phoneNo = this.task['phoneNumber'] || this.task['phoneNo'] || this.task['prospectPhoneNumber'] || '';

        let object = {

          "firstName": this.task['firstName'],
          "email": this.task['prospectEmailid'],
          "phoneNumber": phoneNo

        }


        if (phoneNo && this.leadContactsData.length === 0) {
          this.leadContactsData.push(object);
        }

        this.leadPhoneNumbers = this.leadContactsData.map(contact => contact.phoneNumber).filter(phone => phone);
      } else {

        this.fromSequence = false;
        this.fromLeads = false;
      }

      this.initializeForm();

      this.cdRef.markForCheck();

      setTimeout(() => {
        this.cdRef.detectChanges();
      }, 100);
    });

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        this.whatsappVendorId = this.crmSettingsData.whatsappVendorId;
        this.whatsappContactId = this.crmSettingsData.whatsappContactId;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }
    this.getUpdatedData();
    this.loadTemplates();
    this.getAllContactGroup();

    this.checkTemplateDetails();

    // If coming from sequence, load template by UID
    if (this.fromSequence) {
      if (this.sequenceWhatsappTemplateUid) {
        this.loadTemplateByUid(this.sequenceWhatsappTemplateUid);
      } else if (this.task && this.task.whatsappJson) {
        this.fallbackToTaskWhatsappJson();
      }
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the task object when moving between tasks (pagination)
    if (changes['task'] && changes['task'].currentValue) {
      const task = changes['task'].currentValue;

      // If we are coming from sequence (as indicated by the parent)
      if (this.fromSequence || this.type == 2) {
        this.sequenceTaskId = task['taskId'] || '';
        const newTemplateUid = task['whatsappTemplateUid'] || '';

        // Update lead contacts for the new task to ensure correct variables/placeholders
        const phoneNo = task['phoneNumber'] || task['phoneNo'] || task['prospectPhoneNumber'] || '';
        const leadObj = {
          firstName: task['firstName'],
          email: task['prospectEmailid'],
          phoneNumber: phoneNo
        };

        this.leadContactsData = [leadObj];
        this.leadPhoneNumbers = [phoneNo].filter(p => p);

        // Always reload/re-patch if template UID is present, even if it's the same UID,
        // to ensure the form is reset/re-initialized for the new lead/task context.
        if (newTemplateUid) {
          this.sequenceWhatsappTemplateUid = newTemplateUid;
          this.loadTemplateByUid(newTemplateUid);
        } else if (task['whatsappJson']) {
          this.sequenceWhatsappTemplateUid = '';
          this.fallbackToTaskWhatsappJson();
        } else {
          // If no template is associated with this task, reset the view
          this.backtotemplateSelection();
        }
      }
    }

    // Handle explicit changes to sequenceWhatsappTemplateUid input
    if (changes['sequenceWhatsappTemplateUid'] &&
      changes['sequenceWhatsappTemplateUid'].currentValue &&
      !changes['sequenceWhatsappTemplateUid'].firstChange) {
      this.loadTemplateByUid(changes['sequenceWhatsappTemplateUid'].currentValue);
    }

    // Update fromSequence flag if it changes
    if (changes['fromSequence']) {
      this.fromSequence = changes['fromSequence'].currentValue;
    }

    // Update leadContactsData if it changes
    if (changes['leadContactsData'] && changes['leadContactsData'].currentValue) {
      this.leadContactsData = changes['leadContactsData'].currentValue;
      this.leadPhoneNumbers = this.leadContactsData.map(contact => contact.phoneNumber).filter(phone => phone);
    }

    this.cdRef.markForCheck();
  }

  getUpdatedData() {
    this.vendorSettingsService.getAllUpdatedSettingData().subscribe(setting => {
      this.vendorSettingsData = setting['data'];
      const phoneNumbers = this.vendorSettingsData?.configurationData?.whatsapp_phone_numbers || [];
      if (phoneNumbers.length > 0) {
        this.senderPhoneNumbers = phoneNumbers.map((p: any) => ({
          number: p.display_phone_number,
          id: p.id,
          name: p.verified_name || 'Primary'
        }));
        this.currentPhoneNUmber = this.senderPhoneNumbers[0].number;
        this.currentPhoneNumberID = this.senderPhoneNumbers[0].id;
        this.templateForm?.get('senderPhoneNumber')?.setValue(this.currentPhoneNUmber);
      }
    });


  }
  backtotemplateSelection(): void {
    this.isTemplateSelected = false;
    this.selectedTemplate = null;
    this.mainTemplateData = null;
    this.parsedData = null;
    this.clearTemplateSearch();
    this.resetForm();
    localStorage.removeItem('selectedTemplateDetails'); // Optional: Clear storage if needed
  }
  variables: string[] = [];
  variableValues: { [key: string]: string } = {};
  showDynamicVariable: any;
  selectedTempalateData: any;
  urlButtons: any[] = [];
  copyCodeButtons: any[] = [];
  buttonVariableValues: any = {};
  showButtonVariables = false;
  originalHeaderMediaUrl: string | null = null;
  showMediaUploadControls = false;

  private setupTemplateSearch(): void {
    this.templateSearchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this._onDestroy)
    ).subscribe((value: string) => {
      const rawValue = (value || '').toString();
      const normalizedValue = rawValue.replace(/^\s+/, '');

      if (normalizedValue !== rawValue) {
        this.templateSearchControl.setValue(normalizedValue, { emitEvent: false });
      }

      if (!normalizedValue.trim()) {
        this.filteredTemplateNames = [];
        this.noTemplateSearchResults = false;
        this.templateSearchLoading = false;
        this.cdRef.markForCheck();
        return;
      }

      let status = 'APPROVED'

      const searchTerm = "(a.templateName:'" + '*' + normalizedValue.trim() + '*'
        + "'  OR a.language:'" + '*' + normalizedValue.trim() + '*'
        + "') AND (a.status :'" + '*' + status + ',*)';

      this.filterOption(searchTerm);
    });
  }

  private setupContactGroupSearch(): void {
    this.contactGroupSearchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this._onDestroy)
    ).subscribe((value: string) => {
      const rawValue = (value || '').toString();
      const normalizedValue = rawValue.replace(/^\s+/, '');

      if (normalizedValue !== rawValue) {
        this.contactGroupSearchControl.setValue(normalizedValue, { emitEvent: false });
      }

      if (!normalizedValue.trim()) {
        // if empty, show full list
        this.filteredContactGroups = this.contactGroupList || [];
        this.noContactGroupSearchResults = false;
        this.contactGroupSearchLoading = false;
        this.cdRef.markForCheck();
        return;
      }

      const searchTerm = "title:'" + '*' + normalizedValue.trim() + '*' + "' ";

      this.contactGroupFilter(searchTerm);
    });
  }

  getTemplateSearchLabel(template: any): string {
    const templateName = template?.templateName || template?.name || '';
    const language = template?.language || template?.languageCode || '';
    return language ? `${templateName} - ${language}` : templateName;
  }

  onTemplateSearchInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const rawValue = inputElement.value || '';
    const normalizedValue = rawValue.replace(/^\s+/, '');

    if (normalizedValue !== rawValue) {
      inputElement.value = normalizedValue;
      this.templateSearchControl.setValue(normalizedValue);
    }
  }

  onTemplateSelected(event: any, template: any): void {
    if (event && event.isUserInput !== false && template) {
      this.templateSearchControl.setValue(this.getTemplateSearchLabel(template), { emitEvent: false });
      this.selectTemplate(template);
    }
  }

  onTemplateAutocompleteClosed(): void {
    if (this.isTemplateSelected) {
      return;
    }

    const typedValue = (this.templateSearchControl.value || '').toString().trim();
    if (!typedValue) {
      return;
    }

    const exactMatch = (this.filteredTemplateNames || []).find(template =>
      this.getTemplateSearchLabel(template).toLowerCase() === typedValue.toLowerCase()
    );

    if (!exactMatch) {
      this.templateSearchControl.reset('', { emitEvent: false });
    }
  }

  filterOption(searchTerm: string): void {
    this.templateSearchLoading = true;
    this.noTemplateSearchResults = false;

    this.WhatsappTemplateService.searchTemplates(searchTerm, this.page, this.size).pipe(
      takeUntil(this._onDestroy)
    ).subscribe({
      next: (response) => {
        this.filteredTemplateNames = response?.content || [];
        this.noTemplateSearchResults = this.filteredTemplateNames.length === 0;
        this.templateSearchLoading = false;
        this.cdRef.markForCheck();
      },
      error: (error) => {
        console.error('Error searching templates', error);
        this.filteredTemplateNames = [];
        this.noTemplateSearchResults = true;
        this.templateSearchLoading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  clearTemplateSearch(): void {
    this.templateSearchControl.reset('', { emitEvent: false });
    this.filteredTemplateNames = [];
    this.noTemplateSearchResults = false;
    this.templateSearchLoading = false;
  }

  private selectTemplate(selectedTemplate: any): void {
    if (!selectedTemplate) {
      return;
    }

    this.isTemplateSelected = false;
    this.mainTemplateData = selectedTemplate;

    try {
      this.parsedData = selectedTemplate.data
        ? JSON.parse(selectedTemplate.data)
        : selectedTemplate;

      this.selectedTemplate = this.parsedData.template;
      this.init = true;

      this.loadTemplateFromJson(this.parsedData);
    } catch (error) {
      console.error('Error parsing template data', error);
      this.selectedTemplate = this.parsedData?.template || selectedTemplate;
    }
    if (selectedTemplate) {
      const dynamicGroup = this.fb.group({});
      const buttonGroup = this.fb.group({})

      this.variables = [];
      this.variableValues = {};
      this.showDynamicVariable = false;


      let data = selectedTemplate.data;
      this.selectedTempalateData = JSON.parse(data);

      const bodyComponent = this.selectedTempalateData.template.components.find(
        (comp: any) => comp.type === "BODY"
      );
      this.urlButtons = [];
      this.copyCodeButtons = [];
      this.buttonVariableValues = {};
      this.showButtonVariables = false;

      const buttonsComponent = this.selectedTempalateData.template.components.find(
        (comp: any) => comp.type === "BUTTONS"
      );
      this.variables.forEach(varNum => {
        dynamicGroup.addControl('var_' + varNum, new FormControl(''));
      });

      if (buttonsComponent && buttonsComponent.buttons) {
        buttonsComponent.buttons.forEach((button: any, idx: number) => {
          const buttonKey = `button_${idx}`;

          if (button.type === "COPY_CODE") {
            this.copyCodeButtons.push({
              key: buttonKey,
              text: button.text,
              example: button.example?.[0] || ''
            });
            this.buttonVariableValues[buttonKey] = button.example?.[0] || '';
            this.showButtonVariables = true;
          }
          else if (button.type === "URL") {
            const variables: string[] = [];
            const regex = /\{\{(\d+)\}\}/g;
            let match;

            while ((match = regex.exec(button.url)) !== null) {
              variables.push(match[1]);
            }

            this.urlButtons.push({
              key: buttonKey,
              text: button.text,
              url: button.url,
              variables: variables
            });

            this.buttonVariableValues[buttonKey] = {};
            variables.forEach(varNum => {
              this.buttonVariableValues[buttonKey][varNum] = '';
            });

            this.showButtonVariables = true;
          }
        });
      }
      if (bodyComponent?.text) {
        const regex = /\{\{(\d+)\}\}/g;
        let matches;
        while ((matches = regex.exec(bodyComponent.text)) !== null) {
          if (!this.variables.includes(matches[1])) {
            this.variables.push(matches[1]);
          }
        }
        this.showDynamicVariable = this.variables.length > 0;
      }
      const headerComponent = this.selectedTempalateData.template.components.find(
        (comp: any) => comp.type === "HEADER"
      );

      this.showMediaUploadControls = false;
      this.uploadedMediaUrl = null;

      if (headerComponent?.format &&
        ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.format)) {
        this.headerMediaType = headerComponent.format;
        this.showMediaUpload = true;
        this.originalHeaderMediaUrl = headerComponent.example?.header_handle?.[0];
      } else {
        this.headerMediaType = null;
        this.showMediaUpload = false;
        this.originalHeaderMediaUrl = null;
      }
      if (headerComponent?.format === 'LOCATION') {
        this.showLocationFields = true;
      } else {
        this.showLocationFields = false;
      }

    }

    this.isTemplateSelected = true;
    this.clearTemplateSearch();
  }

  onSelectTemplate(index: number): void {
    if (!this.templateNames || index >= this.templateNames.length) return;

    this.selectTemplate(this.templateNames[index]);

  }
  // Add helper method
  setLocationExample(field: string): void {
    this.templateForm.get(`location${field.charAt(0).toUpperCase() + field.slice(1)}`)
      ?.setValue(this.locationExamples[field]);
  }
  isMediaUploaded = false;
  toggleMediaUpload() {
    this.showMediaUploadControls = !this.showMediaUploadControls;
    if (!this.showMediaUploadControls) {
      this.uploadedMediaUrl = null; // Clear upload on cancel
      this.isMediaUploaded = false;
    }
  }
  orginalFileName: any;
  bannerServerPath = environment.commonImageApi + '/whatsapp/';
  mediaRequiredError = false;

  handleMediaUpload(event: any, mediaType: string): void {

    let fileName = '';
    let fullPath = '';
    let mimeType = '';

    if (event && event.productEntityMediaGallery && event.productEntityMediaGallery.length > 0) {

      let cid = localStorage.getItem(Constant.enterPriseKey);
      this.orginalFileName = event.productEntityMediaGallery[0].fileName;
      fileName = event.productEntityMediaGallery[0].fileName;
      fileName = fileName.split('/').pop() || '';
      fileName = fileName;
      this.uploadedMediaUrl = this.bannerServerPath + fileName + "&cid=" + cid;
      mimeType = event.productEntityMediaGallery[0].fileType;
      this.fileNameNew = fileName;
      this.isMediaUploaded = true;
      this.mediaRequiredError = false;
      this.uploadedMediaType = mediaType;

    }


  }
  clearMedia(mediaType: string): void {
    this.uploadedMediaUrl = null;
    this.showMediaUploadControls = false;
  }

  private resetForm(): void {
    if (this.templateForm) {
      this.templateForm.reset();
    }
    this.bodyVariables = [];
    this.uploadedMediaUrl = null;
    this.uploadedMediaType = null;
    this.variables = [];
    this.variableValues = {};
    this.showDynamicVariable = false;
    this.urlButtons = [];
    this.copyCodeButtons = [];
    this.buttonVariableValues = {};
    this.showButtonVariables = false;
    this.originalHeaderMediaUrl = null;
    this.showMediaUploadControls = false;
    this.headerMediaType = null;
    this.showMediaUpload = false;
    this.showLocationFields = false;
    this.isMediaUploaded = false;
    this.fileNameNew = '';
    this.orginalFileName = null;
    this.mediaRequiredError = false;
    // Reset other form controls as needed
    this.initializeForm();
  }




  checkTemplateDetails() {
    const encryptedStored = localStorage.getItem('selectedTemplateDetails');
    if (encryptedStored) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedStored);
        const parsed = JSON.parse(decrypted);
        this.mainTemplateData = parsed;
        this.parsedData = JSON.parse(parsed.data);
        this.isTemplateSelected = true;

        // Set selectedTemplate directly from parsed data
        this.selectedTemplate = this.parsedData.template;
        this.init = true;

        this.loadTemplateFromJson(this.parsedData);

        if (this.parsedData) {
          let headerComponent = this.parsedData.template.components.find(
            (comp: any) => comp.type === "HEADER"
          );
          if (headerComponent?.format &&
            ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.format)) {
            this.headerMediaType = headerComponent.format;
            this.showMediaUpload = true;
          } else {
            this.headerMediaType = null;
            this.showMediaUpload = false;
          }
        }
      } catch (error) {
        console.error('Error loading template from localStorage:', error);
        this.isTemplateSelected = false;
        this.selectedTemplate = null;
      }
    } else {
      this.isTemplateSelected = false;
      this.selectedTemplate = null;
    }
  }


  initializeForm(): void {
    this.templateForm = this.fb.group({
      templateName: ['', Validators.required],
      languageCode: ['', Validators.required],
      category: ['', Validators.required],
      headerType: ['0'],
      headerTextBody: [''],
      headerTextExample: [''],
      uploadedMediaFileName: [''],
      templateBody: ['', Validators.required],
      templateFooter: [''],
      // Campaign form controls
      campaignTitle: ['', [

        conditionalValidator(
          (() => this.type != 2),
          Validators.required,
        ),
      ]],
      recipientType: ['contact'],
      leadSelectType: ['all'],
      defaultLeadOwner: [[]], // multiselect - holds array of owner entity IDs
      contactGroup: [null], // Validators set dynamically in onRecipientTypeChange
      restrictLanguage: [false],
      scheduleType: ['now'],
      scheduleDate: [''],
      scheduleTime: [''],
      timezone: ['Asia/Kolkata'],
      scheduleDateTime: ['', [this.futureDateValidator()]],
      senderPhoneNumber: [this.senderPhoneNumbers[0]?.number || '', Validators.required],
      dynamicVariables: this.fb.group({}),
      buttonVariables: this.fb.group({}),
      leadCreatedStartDate: [''],
      leadCreatedEndDate: [''],
      leadUpdatedStartDate: [''],
      leadUpdatedEndDate: [''],
      leadStatus: [[]],
      leadSource: [[]],
      whatsappMessageSent: [''],
      whatsappMessageSentStartDate: [''],
      whatsappMessageSentEndDate: ['']
    });

    this.onRecipientTypeChange('contact');

    this.customButtons = {
      data: [],
      totalButtonsUsed: 0,
      totalAllowedButtons: 3,
      buttonUsesByTypes: {
        PHONE_NUMBER: 0,
        PHONE_NUMBER_LIMIT: 1,
        COPY_CODE: 0,
        COPY_CODE_LIMIT: 1,
        URL_BUTTON: 0,
        URL_BUTTON_LIMIT: 2,
      }
    };
    this.templateForm.addControl('locationLatitude', new FormControl(''));
    this.templateForm.addControl('locationLongitude', new FormControl(''));
    this.templateForm.addControl('locationName', new FormControl(''));
    this.templateForm.addControl('locationAddress', new FormControl(''));
  }
  onHeaderTypeChange(): void {
    this.templateForm.patchValue({
      headerTextBody: '',
      headerTextExample: '',
      uploadedMediaFileName: ''
    });
    this.enableHeaderVariableExample = false;
  }
  private loadTemplates(): void {
    this.WhatsappTemplateService.getTemplatesByList(
    ).subscribe({
      next: (response) => {
        this.templateNames = response || [];
        this.showListofTemplates = true;
      },
      error: (err) => {
        console.error('Error fetching templates', err);
        this.templateNames = [];
      }
    });
  }

  private loadTemplateByUid(uid: string): void {

    this.WhatsappTemplateService.getTemplatesByList().subscribe({
      next: (response) => {
        if (response && Array.isArray(response)) {
          const template = response.find((t: any) =>
            t.uid === uid ||
            t.templateUid === uid ||
            t.templateId === uid
          );

          if (template) {
            this.mainTemplateData = template;

            // Parse template data
            try {
              this.parsedData = template.data ? JSON.parse(template.data) : template;
              this.selectedTemplate = this.parsedData.template || this.parsedData;
              this.init = true;

              // Auto-populate form with template data
              this.loadTemplateFromJson(this.parsedData);

              // Mark as template selected
              this.isTemplateSelected = true;

              this.cdRef.detectChanges();
            } catch (error) {

            }
          } else {
            this.fallbackToTaskWhatsappJson();
          }
        }
      },
      error: (err) => {
        console.error('Error fetching template by UID:', err);
        this.fallbackToTaskWhatsappJson();
      }
    });
  }

  private fallbackToTaskWhatsappJson(): void {
    if (!this.task || !this.task.whatsappJson) return;
    try {
      const fallbackData = typeof this.task.whatsappJson === 'string'
        ? JSON.parse(this.task.whatsappJson)
        : this.task.whatsappJson;

      if (fallbackData && fallbackData.template) {
        this.mainTemplateData = fallbackData;
        this.parsedData = fallbackData;
        this.selectedTemplate = fallbackData.template;
        this.init = true;
        this.loadTemplateFromJson(this.parsedData);
        this.isTemplateSelected = true;
        this.cdRef.detectChanges();
      }
    } catch (e) {
      console.error('Error applying fallback whatsappJson', e);
    }
  }

  handleTemplateResponse(response: any) {
    this.templateNames = response;
    this.showListofTemplates = true;
  }
  formatText(formatType: string): void {
    const textarea = document.getElementById('templateBody') as HTMLTextAreaElement;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    let formattedText = '';

    switch (formatType) {
      case 'bold':
        formattedText = `*${selectedText}*`;
        break;
      case 'italic':
        formattedText = `_${selectedText}_`;
        break;
      case 'strikethrough':
        formattedText = `~${selectedText}~`;
        break;
      case 'code':
        formattedText = "```" + selectedText + "```";
        break;
      default:
        formattedText = selectedText;
    }

    const newText = textarea.value.substring(0, start) + formattedText + textarea.value.substring(end);
    this.templateForm.patchValue({ templateBody: newText });

    setTimeout(() => {
      textarea.selectionStart = start + (formattedText.length - selectedText.length);
      textarea.selectionEnd = start + (formattedText.length - selectedText.length);
    });
  }
  loadTemplateFromJson(templateJson: any): void {
    this.templateJson = templateJson;
    this.resetForm();

    if (!templateJson?.template) return;
    this.selectedTemplate = templateJson.template;

    // If parent task provides a whatsappJson override (sequence/task flow),
    // prefer its top-level headerVideo/headerImage/headerDocument to replace
    // the template HEADER component so the preview shows the overridden media.
    try {
      let overrideJson: any = null;
      if (this.task && this.task.whatsappJson) {
        overrideJson = typeof this.task.whatsappJson === 'string'
          ? JSON.parse(this.task.whatsappJson)
          : this.task.whatsappJson;
      }

      // Also allow override from the passed templateJson itself (rare cases)
      if (!overrideJson && (templateJson.headerVideo || templateJson.headerImage || templateJson.headerDocument)) {
        overrideJson = {
          headerVideo: templateJson.headerVideo,
          headerImage: templateJson.headerImage,
          headerDocument: templateJson.headerDocument
        };
      }

      if (overrideJson) {
        const headerUrl = overrideJson.headerVideo || overrideJson.headerImage || overrideJson.headerDocument;
        const format = overrideJson.headerVideo ? 'VIDEO' : (overrideJson.headerImage ? 'IMAGE' : 'DOCUMENT');

        if (headerUrl) {
          let headerComponent = this.selectedTemplate.components.find((c: any) => c.type === 'HEADER');
          if (headerComponent) {
            headerComponent.format = format;
            headerComponent.example = headerComponent.example || {};
            headerComponent.example.header_handle = [headerUrl];
            // clear text if any
            if (headerComponent.text) delete headerComponent.text;
          } else {
            // Insert a HEADER component at the start so preview shows it
            const newHeader: any = { type: 'HEADER', format: format, example: { header_handle: [headerUrl] } };
            this.selectedTemplate.components = [newHeader, ...this.selectedTemplate.components];
          }
        }
      }
    } catch (e) {
      // ignore JSON parse or other errors and continue with original template
      console.error('Error applying header override from task whatsappJson', e);
    }

    this.templateForm.patchValue({
      templateName: this.selectedTemplate.name,
      languageCode: this.selectedTemplate.language,
      category: this.selectedTemplate.category
    });
    this.selectedTemplate.components.forEach((component: any) => {
      switch (component.type) {
        case 'HEADER':
          this.processHeaderComponent(component);
          break;
        case 'BODY':
          this.processBodyComponent(component);
          break;
        case 'FOOTER':
          this.templateForm.patchValue({ templateFooter: component.text });
          break;
        case 'BUTTONS':
          this.processButtonsComponent(component);
          break;
      }
    });
  }
  private processHeaderComponent(component: any): void {
    if (component.format === 'TEXT') {
      this.templateForm.patchValue({
        headerType: 'text',
        headerTextBody: component.text
      });
    } else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(component.format)) {
      this.templateForm.patchValue({
        headerType: component.format.toLowerCase()
      });

      this.uploadedMediaType = component.format.toLowerCase();
      this.uploadedMediaUrl = component.example?.header_handle?.[0] || null;
    } else if (component.format === 'LOCATION') {
      this.templateForm.patchValue({ headerType: 'location' });

    }
  }

  private processBodyComponent(component: any): void {
    this.templateForm.patchValue({ templateBody: component.text });

    const variableRegex = /{{(\d+)}}/g;
    let match: RegExpExecArray | null;
    const variables = new Set<string>();
    while ((match = variableRegex.exec(component.text)) !== null) {
      variables.add(match[1]);
    }

    Array.from(variables).forEach((varNum, index) => {
      const exampleValue = component.example?.body_text?.[0]?.[index] || '';
      this.bodyVariables.push({ textVariable: `{{${varNum}}}` });
      this.templateForm.addControl(`exampleBodyField_${index}`, new FormControl(exampleValue));
    });
  }

  private processButtonsComponent(component: any): void {
    component.buttons?.forEach((button: any) => {
      let buttonType = '';

      switch (button.type) {
        case 'PHONE_NUMBER':
          buttonType = 'PHONE_NUMBER';
          break;
        case 'URL':
          buttonType = button.example?.[0]?.includes('{{') ? 'DYNAMIC_URL_BUTTON' : 'URL_BUTTON';
          break;
        case 'QUICK_REPLY':
          buttonType = 'QUICK_REPLY';
          break;
        case 'COPY_CODE':
          buttonType = 'COPY_CODE';
          break;
      }

      if (buttonType) {
        const newButton: ButtonData = {
          buttonIndex: this.customButtons.data.length,
          buttonType: buttonType,
          text: button.text,
          phoneNumber: button.phone_number,
          url: button.url,
          example: button.example?.[0]
        };

        this.customButtons.data.push(newButton);
        this.customButtons.totalButtonsUsed++;
        this.customButtons.buttonUsesByTypes[buttonType]++;
      }
    });
  }


  customButtons: CustomButtons = {
    data: [],
    totalButtonsUsed: 0,
    totalAllowedButtons: 3,
    buttonUsesByTypes: {
      PHONE_NUMBER: 0,
      PHONE_NUMBER_LIMIT: 1,
      COPY_CODE: 0,
      COPY_CODE_LIMIT: 1,
      URL_BUTTON: 0,
      URL_BUTTON_LIMIT: 2,
    }
  };

  addButton(buttonType: string): void {
    if (this.customButtons.totalButtonsUsed >= this.customButtons.totalAllowedButtons) return;

    const newButton: ButtonData = {
      buttonIndex: this.customButtons.data.length,
      buttonType: buttonType
    };

    this.customButtons.data.push(newButton);
    this.customButtons.totalButtonsUsed++;
    this.customButtons.buttonUsesByTypes[buttonType]++;
  }

  deleteButton(index: number): void {
    const buttonToDelete = this.customButtons.data.find(b => b.buttonIndex === index);
    if (buttonToDelete) {
      this.customButtons.buttonUsesByTypes[buttonToDelete.buttonType]--;
      this.customButtons.totalButtonsUsed--;
      this.customButtons.data = this.customButtons.data.filter(b => b.buttonIndex !== index);
    }
  }

  formatWhatsAppText(text: string): any {
    if (!text) return '';
    let formatted = text
      .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
      .replace(/_(.*?)_/g, '<em>$1</em>')
      .replace(/~(.*?)~/g, '<del>$1</del>')
      .replace(/```([\s\S]*?)```/g, '<code>$1</code>')
      .replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }
  addVariable(): void {
    this.enableHeaderVariableExample = true;
    const variableName = `var${this.bodyVariables.length + 1}`;
    this.bodyVariables.push({ textVariable: `{{${variableName}}}` });

    this.templateForm.addControl(`exampleBodyField_${this.bodyVariables.length - 1}`,
      new FormControl(''));

    const textarea = document.getElementById('templateBody') as HTMLTextAreaElement;
    const start = textarea.selectionStart;
    const currentText = this.templateForm.get('templateBody')?.value || '';
    const newText = currentText.substring(0, start) + ` {{${variableName}}} ` + currentText.substring(start);
    this.templateForm.patchValue({ templateBody: newText });

    setTimeout(() => {
      textarea.selectionStart = start + ` {{${variableName}}} `.length;
      textarea.selectionEnd = start + ` {{${variableName}}} `.length;
      textarea.focus();
    });
  }
  backtotemplates() {
    this.router.navigate(['/templateScreen']);
  }

  whatsappCampaign() {
    this.router.navigate(['/whatsappCampaign'])
  }

  onFileSelected(event: Event, type: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadedMediaFileName = file.name;
      this.uploadedMediaType = type;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedMediaUrl = e.target?.result || null;
      };
      reader.readAsDataURL(file);

      this.templateForm.patchValue({
        uploadedMediaFileName: file.name
      });
    }
  }
  getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }

  onSubmit(): void {
    if (!this.fromSequence) {
      this.templateSearchControl.markAsTouched();
    }

    if ((!this.fromSequence && this.templateSearchControl.invalid) || !this.selectedTemplate || !this.mainTemplateData) {
      if (!this.fromSequence) {
        this.templateSearchControl.markAsTouched();
      }
      this.snackBar.open('Please select a valid template.', 'Close', {
        duration: 3000,
        verticalPosition: 'bottom',
        panelClass: ['error']
      });
      if (this.type == 2) {
        this.formFieldInvalid.emit("invalid");
      }
      return;
    }


    if (this.templateForm.invalid) {

      this.templateForm.markAllAsTouched();


      Object.keys(this.templateForm.controls).forEach(key => {
        const control = this.templateForm.get(key);
        if (control && control.invalid) {

        }
      });


      if (this.type == 2) {

        this.formFieldInvalid.emit("invalid");

      } else {
        return;
      }
    }
    if (this.templateForm.valid) {
      const formData = {
        ...this.templateForm.value,
        buttons: this.customButtons.data,
        exampleBodyFields: this.bodyVariables.map((_, i) =>
          this.templateForm.get(`exampleBodyField_${i}`)?.value)
      };
      const contactGroupValue = this.templateForm.get('contactGroup')?.value;
      const contactGroupId = contactGroupValue === 'all_contacts' ? 'all_contacts' : Number(contactGroupValue);
      const scheduleType = this.templateForm.get('scheduleType')?.value;

      const recipientType = this.templateForm.get('recipientType')?.value;

      const campaignResultData: any = {
        templateUid: this.fromSequence && this.sequenceWhatsappTemplateUid
          ? this.sequenceWhatsappTemplateUid
          : this.mainTemplateData?.uid,
        header_field_1: "dynamic_contact_full_name",
        title: this.templateForm.get('campaignTitle')?.value || 'Sequence Campaign',
        timezone: this.templateForm.get('timezone')?.value,
        fromPhoneNumberId: "729877163537894"
      };

      if (recipientType === 'lead') {
        campaignResultData.recipientType = 'lead';
        campaignResultData.leadSelectType = this.templateForm.get('leadSelectType')?.value;
        if (campaignResultData.leadSelectType === 'particular') {
          // Strip single quotes from the search term
          let searchStr = this.campaignLeadFilterSearchTerm != null ? this.campaignLeadFilterSearchTerm.split("'").join('') : null;

          campaignResultData.defaultLeadOwner = searchStr;

          // Send the search string so the backend processes the leads
          campaignResultData.search = searchStr || "*:*";

          // Also explicitly send as searchStr in case backend relies on this exact key
          campaignResultData.searchStr = searchStr || "*:*";
        }
      } else {
        campaignResultData.recipientType = 'contact';
        if (this.fromLeads || this.leadContactsData.length > 0) {
          campaignResultData.leadContacts = this.leadContactsData;
        } else {
          campaignResultData.contactGroup = contactGroupId;
        }
      }

      if (this.templateForm.get('headerType')?.value === 'location') {
        campaignResultData.location_latitude = this.templateForm.get('locationLatitude')?.value;
        campaignResultData.location_longitude = this.templateForm.get('locationLongitude')?.value;
        campaignResultData.location_name = this.templateForm.get('locationName')?.value;
        campaignResultData.location_address = this.templateForm.get('locationAddress')?.value;
      }
      this.urlButtons.forEach((button, index) => {
        const values = this.buttonVariableValues[button.key];
        if (values && typeof values === 'object') {
          const firstKey = Object.keys(values)[0];
          campaignResultData[`button_${index}`] = values[firstKey];
        }
      });
      if (this.copyCodeButtons.length > 0) {
        const firstCopyButton = this.copyCodeButtons[0];
        campaignResultData.copy_code = this.buttonVariableValues[firstCopyButton.key];
      }
      if (this.headerMediaType) {
        try {
          const raw = String(this.uploadedMediaUrl || this.originalHeaderMediaUrl || '');

          // If it's a data/blob URL, keep as-is
          if (/^data:|^blob:/i.test(raw)) {
            if (this.headerMediaType === 'IMAGE') {
              campaignResultData.headerImage = raw;
            } else if (this.headerMediaType === 'VIDEO') {
              campaignResultData.headerVideo = raw;
            } else if (this.headerMediaType === 'DOCUMENT') {
              campaignResultData.headerDocument = raw;
              campaignResultData.headerDocumentName = this.orginalFileName || '';
            }
          } else {
            const enterpriseCid = localStorage.getItem(Constant.enterPriseKey) || localStorage.getItem('cid') || '';
            let url = raw;

            if (enterpriseCid) {
              // Replace cid=null or cid=undefined with actual enterprise CID
              url = url.replace(/([?&]cid=)(null|undefined|)(?=(&|$))/ig, `$1${encodeURIComponent(enterpriseCid)}`);

              // If there's no cid param at all, append it
              if (!/[?&]cid=/i.test(url)) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + 'cid=' + encodeURIComponent(enterpriseCid);
              }
            } else {
              // remove explicit null/undefined cid values to avoid literal 'null' in URLs
              url = url.replace(/([?&])cid=(null|undefined|)/ig, '$1cid=');
            }

            if (this.headerMediaType === 'IMAGE') {
              campaignResultData.headerImage = url;
            } else if (this.headerMediaType === 'VIDEO') {
              campaignResultData.headerVideo = url;
            } else if (this.headerMediaType === 'DOCUMENT') {
              const fileNameOnly = url.split('/').pop()?.split('?')[0] || '';
              campaignResultData.headerDocument = url;
              campaignResultData.headerDocumentName = this.orginalFileName || fileNameOnly;
            }
          }
        } catch (e) {
          const fallback = String(this.uploadedMediaUrl || this.originalHeaderMediaUrl || '');
          if (this.headerMediaType === 'IMAGE') {
            campaignResultData.headerImage = fallback;
          } else if (this.headerMediaType === 'VIDEO') {
            campaignResultData.headerVideo = fallback;
          } else if (this.headerMediaType === 'DOCUMENT') {
            campaignResultData.headerDocument = fallback;
            campaignResultData.headerDocumentName = this.orginalFileName || '';
          }
        }
      }

      let result = true;
      if (scheduleType === 'now') {
        campaignResultData.schedule_now = "now";
      } else if (scheduleType === 'later') {

        this.templateForm.value.scheduleTime = this.convertToAMPMFormat(this.templateForm.value.scheduleTime, 0);
        result = this.isGivenTimeGreaterThanCurrentTime(this.templateForm.value.scheduleTime, this.templateForm.value.scheduleDate)
        if (!result) {
          this.templateForm.get('scheduleTime')?.setErrors({ invalidTime: true });
          this.templateForm.markAllAsTouched();
          return;
        }
        campaignResultData.scheduleTime = this.templateForm.value.scheduleTime;

        campaignResultData.scheduleDate = this.templateForm.value.scheduleDate;

      }

      if (this.type == 2) {
        campaignResultData.sequenceId = this.task['sequenceId'];
        campaignResultData.stepId = this.task['stepId'];
        campaignResultData.taskId = this.task['taskId'];
        campaignResultData.taskStep = this.task['taskStep'];
        campaignResultData.stepNotes = this.task['stepNotes'];

      }

      if (this.showMediaUpload && !this.isMediaUploaded && !this.originalHeaderMediaUrl) {
        this.mediaRequiredError = true;
        this.snackBar.open(`Please upload a new ${this.headerMediaType} file`, 'Close', {
          duration: 3000,
          panelClass: 'error'
        });
        return;
      }

      this.text = "Processing";
      this.cdRef.detectChanges();


      if (this.type == 2) {

        this.getInputJson.emit(campaignResultData);

      } else {

        const successMessage = scheduleType === 'now' ? 'Campaign Created successfully' : 'Campaign scheduled successfully';

        this.campaignService.sheduleCampaign(campaignResultData).subscribe({
          next: (res: string) => {
            this.text = "Schedule Campaign";
            this.cdRef.detectChanges();

            this.snackBar.open(successMessage, 'Close', {
              duration: 3000,
              verticalPosition: 'bottom',
              panelClass: ['success']
            });

            // Don't navigate if coming from sequence
            if (!this.fromSequence) {
              this.router.navigate(['/whatsappCampaign']);
            }

          },
          error: (err) => {
            this.text = "Schedule Campaign";
            this.cdRef.detectChanges();
            console.error('Error scheduling campaign:', err);
            this.snackBar.open(successMessage, 'Close', {
              duration: 3000,
              verticalPosition: 'bottom',
              panelClass: ['success']
            });

            // Don't navigate if coming from sequence
            if (!this.fromSequence) {
              this.router.navigate(['/whatsappCampaign']);
            }
          }
        });

      }





    }
  }
  patchJson() {
    this.loadTemplateFromJson(this.templateJson);
  }
  ngAfterViewInit() {
    setTimeout(() => this.cdRef.detectChanges());
  }
  campaignForm: FormGroup;
  contactGroups = [
    { id: 'group1', name: 'All Contacts' },
    { id: 'group2', name: 'VIP Customers' },
    { id: 'group3', name: 'New Leads' }
  ];

  senderPhoneNumbers: any[] = [
    { number: '+91 94448 60882', name: 'Primary' },
  ];

  variableOptions = [
    ['First Name', 'Last Name', 'Email'],
    ['Order Number', 'Tracking ID', 'Reference Number'],

  ];


  getVariableOptions(index: number): string[] {
    return this.variableOptions[index % this.variableOptions.length];
  }

  selectVariableOption(index: number, option: string): void {
    this.templateForm.get(`exampleBodyField_${index}`)?.setValue(option);
  }
  timezones: TimezoneOption[] = TIMEZONE_ZONES;
  onScheduleTypeChange(type: string): void {
    if (type === 'later') {
      const now = new Date();
      const later = new Date(now.getTime() + 60 * 60 * 1000); // 1 hour later
      this.campaignForm.get('scheduleDateTime')?.setValue(this.formatDateTime(later));
    }
  }

  private formatDateTime(date: Date): string {
    return date.toISOString().slice(0, 16); // Formats to YYYY-MM-DDTHH:MM
  }

  futureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const selectedDate = new Date(control.value);
      const now = new Date();

      return selectedDate > now ? null : { pastDate: true };
    };
  }
  onSubmitTwo(): void {
    if (this.templateForm.valid && this.campaignForm.valid) {
      const formData = {
        template: {
          ...this.templateForm.value,
          buttons: this.customButtons.data,
          variables: this.bodyVariables.map((_, i) =>
            this.templateForm.get(`exampleBodyField_${i}`)?.value)
        },
        campaign: this.campaignForm.value
      };

    }
  }
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'contactGroupId' + "," + Constant.Dsc;
  getAllContactGroup() {
    this.whatsAppContactGroupService.getAllContactGroup().subscribe(
      res => {
        this.contactGroupList = res;
        // initialize filtered list for autocomplete
        this.filteredContactGroups = Array.isArray(res) ? res : [];
      })
  }

  contactGroupFilter(searchTerm: string): void {
    this.contactGroupSearchLoading = true;
    this.noContactGroupSearchResults = false;

    this.whatsAppContactGroupService.contactGroupSearch(searchTerm, this.page, this.size, this.sortParam).pipe(
      takeUntil(this._onDestroy)
    ).subscribe({
      next: (response: any) => {
        // service returns paginated response - content contains items
        this.filteredContactGroups = response?.content || response || [];
        this.noContactGroupSearchResults = this.filteredContactGroups.length === 0;
        this.contactGroupSearchLoading = false;
        this.cdRef.markForCheck();
      },
      error: (err) => {
        console.error('Error searching contact groups', err);
        this.filteredContactGroups = [];
        this.noContactGroupSearchResults = true;
        this.contactGroupSearchLoading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  onContactSelected(event: any, value: any): void {
    if (!value) return;

    // value may be 'all_contacts' or an id
    let selectedGroup: any = null;
    if (value !== 'all_contacts') {
      selectedGroup = (this.filteredContactGroups || []).find((g: any) => g.contactGroupId == value)
        || (this.contactGroupList || []).find((g: any) => g.contactGroupId == value);
    }

    const id = value === 'all_contacts' ? 'all_contacts' : (selectedGroup ? selectedGroup.contactGroupId : value);

    this.templateForm.controls['contactGroup'].setValue(id);
    this.templateForm.controls['contactGroup'].markAsTouched();
    // store selected group object so future filtering doesn't remove the selection
    if (value === 'all_contacts') {
      this.selectedContactGroup = { contactGroupId: 'all_contacts', title: 'All Contacts' };
    } else if (selectedGroup) {
      this.selectedContactGroup = selectedGroup;
    } else {
      this.selectedContactGroup = { contactGroupId: id, title: id };
    }

    // update the visible input to the group's title
    this.contactGroupSearchControl.setValue(this.selectedContactGroup.title || id, { emitEvent: false });
  }

  onContactAutocompleteClosed(): void {
    const typedValue = (this.contactGroupSearchControl.value || '').toString().trim();
    if (!typedValue) return;
    // If the typed value matches the stored selection, keep it
    if (this.selectedContactGroup && (this.selectedContactGroup.title || '').toLowerCase() === typedValue.toLowerCase()) {
      // keep as-is
      this.contactGroupSearchControl.setValue(this.selectedContactGroup.title, { emitEvent: false });
      return;
    }

    const exactMatch = (this.filteredContactGroups || []).find(g => (g.title || '').toLowerCase() === typedValue.toLowerCase());
    if (!exactMatch) {
      this.contactGroupSearchControl.reset('', { emitEvent: false });
    }
  }

  clearContactGroupSelection(): void {
    this.selectedContactGroup = null;
    if (this.templateForm && this.templateForm.get('contactGroup')) {
      this.templateForm.get('contactGroup')?.reset();
      this.templateForm.get('contactGroup')?.markAsUntouched();
    }
    this.contactGroupSearchControl.reset('', { emitEvent: false });
    // reset filtered list to initial state
    this.filteredContactGroups = Array.isArray(this.contactGroupList) ? this.contactGroupList : [];
    this.cdRef.markForCheck();
  }

  clearTemplateSelection(): void {
    // reuse existing reset logic
    this.templateSearchControl.reset('', { emitEvent: false });
    this.filteredTemplateNames = [];
    this.noTemplateSearchResults = false;
    this.templateSearchLoading = false;
    // this.backtotemplateSelection();
    // this.cdRef.markForCheck();
  }
  onSelectCampaign(event: string | number | any): void {
    if (event) {
      this.templateForm.controls['contactGroup'].setValue(event);
      this.templateForm.controls['contactGroup'].markAsTouched();
    }
  }

  zone: TimezoneOption[] = TIMEZONE_ZONES;

  // kept for reference — DO NOT use inline array below; use TIMEZONE_ZONES instead
  private _zone_unused: any = [

    {
      "value": "IST",
      "label": "IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "Dateline Standard Time",
      "label": "BIT - (GMT-12:00) International Date Line West"
    },
    {
      "value": "Samoa Standard Time",
      "label": "SMST - (GMT-11:00) Midway Island, Samoa"
    },
    {
      "value": "Hawaiian Standard Time",
      "label": "HAST - (GMT-10:00) Hawaii"
    },
    {
      "value": "Alaskan Standard Time",
      "label": "AK - (GMT-09:00) Alaska"
    },
    {
      "value": "Pacific Standard Time",
      "label": "PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana"
    },
    {
      "value": "US Mountain Standard Time",
      "label": "MST - (GMT-07:00) Arizona"
    },
    {
      "value": "Mountain Standard Time (Mexico)",
      "label": "MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
      "value": "Mountain Standard Time",
      "label": "MT - (GMT-07:00) Mountain Time (US and Canada)"
    },
    {
      "value": "Central Standard Time (Mexico)",
      "label": "CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
      "value": "Central Standard Time",
      "label": "CT - (GMT-06:00) Central Time (US and Canada)"
    },
    {
      "value": "Central America Standard Time",
      "label": "CAST - (GMT-06:00) Central America"
    },
    {
      "value": "Canada Central Standard Time",
      "label": "CCST - (GMT-06:00) Saskatchewan"
    },
    {
      "value": "US Eastern Standard Time",
      "label": "EST - (GMT-05:00) Indiana (East)"
    },
    {
      "value": "SA Pacific Standard Time",
      "label": "SAPST - (GMT-05:00) Bogota, Lima, Quito"
    },
    {
      "value": "Eastern Standard Time",
      "label": "ET - (GMT-05:00) Eastern Time (US and Canada)"
    },
    {
      "value": "Central Brazilian Standard Time",
      "label": "CBST - (GMT-04:00) Manaus"
    },
    {
      "value": "SA Western Standard Time",
      "label": "SAWST - (GMT-04:00) Caracas, La Paz"
    },
    {
      "value": "Pacific SA Standard Time",
      "label": "PSAST - (GMT-04:00) Santiago"
    },
    {
      "value": "Atlantic Standard Time",
      "label": "AST - (GMT-04:00) Atlantic Time (Canada)"
    },
    {
      "value": "Newfoundland Standard Time",
      "label": "NST - (GMT-03:30) Newfoundland and Labrador"
    },
    {
      "value": "SA Eastern Standard Time",
      "label": "SAEST - (GMT-03:00) Buenos Aires, Georgetown"
    },
    {
      "value": "Greenland Standard Time",
      "label": "GNST - (GMT-03:00) Greenland"
    },
    {
      "value": "E. South America Standard Time",
      "label": "ESAST - (GMT-03:00) Brasilia"
    },
    {
      "value": "Mid-Atlantic Standard Time",
      "label": "UTC02 - (GMT-02:00) Mid-Atlantic"
    },
    {
      "value": "Cape Verde Standard Time",
      "label": "CVT - (GMT-01:00) Cape Verde Islands"
    },
    {
      "value": "Azores Standard Time",
      "label": "AZOST - (GMT-01:00) Azores"
    },
    {
      "value": "Greenwich Standard Time",
      "label": "GST - (GMT-00:00) Casablanca, Monrovia"
    },
    {
      "value": "GMT Standard Time",
      "label": "GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
      "value": "W. Europe Standard Time",
      "label": "WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
      "value": "W. Central Africa Standard Time",
      "label": "ECT - (GMT+01:00) West Central Africa"
    },
    {
      "value": "Romance Standard Time",
      "label": "RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
      "value": "Central European Standard Time",
      "label": "CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
      "value": "Central Europe Standard Time",
      "label": "CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
      "value": "Namibia Standard Time",
      "label": "NMST - (GMT+02:00) Windhoek"
    },
    {
      "value": "South Africa Standard Time",
      "label": "SAST - (GMT+02:00) Harare, Pretoria"
    },
    {
      "value": "Israel Standard Time",
      "label": "ISST - (GMT+02:00) Jerusalem"
    },
    {
      "value": "GTB Standard Time",
      "label": "GTBST - (GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
      "value": "FLE Standard Time",
      "label": "EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius"
    },
    {
      "value": "Egypt Standard Time",
      "label": "EGST - (GMT+02:00) Cairo"
    },
    {
      "value": "E. Europe Standard Time",
      "label": "EEST - (GMT+02:00) Minsk"
    },
    {
      "value": "Russian Standard Time",
      "label": "MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
      "value": "E. Africa Standard Time",
      "label": "EAT - (GMT+03:00) Nairobi"
    },
    {
      "value": "Arabic Standard Time",
      "label": "ARST - (GMT+03:00) Baghdad"
    },
    {
      "value": "Arab Standard Time",
      "label": "ABST - (GMT+03:00) Kuwait, Riyadh"
    },
    {
      "value": "Iran Standard Time",
      "label": "IRST - (GMT+03:30) Tehran"
    },
    {
      "value": "Georgian Standard Time",
      "label": "GET - (GMT+04:00) Tblisi"
    },
    {
      "value": "Azerbaijan Standard Time",
      "label": "AZT - (GMT+04:00) Baku"
    },
    {
      "value": "Caucasus Standard Time",
      "label": "AMT - (GMT+04:00) Yerevan"
    },
    {
      "value": "Arabian Standard Time",
      "label": "ARBST - (GMT+04:00) Abu Dhabi, Muscat"
    },
    {
      "value": "Afghanistan Standard Time",
      "label": "AFT - (GMT+04:30) Kabul"
    },
    {
      "value": "West Asia Standard Time",
      "label": "WAST - (GMT+05:00) Islamabad, Karachi, Tashkent"
    }

  ]

  convertToAMPMFormat(time: string, minutesAdjustment: number): string {
    // Split the time into hours and minutes
    const [hoursStr, minutesStr] = time.split(':');
    let hours = parseInt(hoursStr, 10);
    let minutes = parseInt(minutesStr, 10);

    // Subtract the adjustment from the minutes
    minutes -= minutesAdjustment;

    // If the adjusted minutes become negative, adjust hours accordingly
    if (minutes < 0) {
      minutes += 60;
      hours--;
    }

    // If hours become negative, wrap around to 23 (assuming time input is in 24-hour format)
    if (hours < 0) {
      hours += 24;
    }

    // Determine the meridiem (AM or PM)
    const meridiem = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    let hours12 = hours % 12;
    hours12 = hours12 || 12; // Handle midnight (0 hours)

    // Return the adjusted time in AM/PM format
    return `${hours12}:${minutes.toString().padStart(2, '0')} ${meridiem}`;
  }


  isGivenTimeGreaterThanCurrentTime(givenTime: string, givenDate: Date): boolean {
    let currentTime = new Date();

    // Compare the given date with the current date
    if (givenDate > currentTime) {
      return true;
    } else {

      let currentTimeHours = currentTime.getHours();
      let currentTimeMinutes = currentTime.getMinutes();

      // Split the given time string into hours, minutes, and period (AM/PM)
      let givenTimeSplit = givenTime.split(':');
      let givenHours = parseInt(givenTimeSplit[0]);
      let givenMinutes = parseInt(givenTimeSplit[1].split(' ')[0]);
      let givenPeriod = givenTimeSplit[1].split(' ')[1]; // AM or PM

      // Convert hours to 24-hour format if it's PM
      if (givenPeriod === 'PM' && givenHours !== 12) {
        givenHours += 12;
      }

      // Compare hours and minutes
      if (
        givenHours > currentTimeHours ||
        (givenHours === currentTimeHours && givenMinutes > currentTimeMinutes)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  submitCampaign() {
    this.onSubmit();
  }

  onSenderPhoneChange(phoneNumber: string): void {
    const selected = this.senderPhoneNumbers.find((p: any) => p.number === phoneNumber);
    if (selected) {
      this.currentPhoneNumberID = selected.id;
      this.currentPhoneNUmber = selected.number;
      this.templateForm.get('senderPhoneNumber')?.setValue(selected.number);
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  getUserDropDownList() {
    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
        this.cdRef.markForCheck();
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }

  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      this.cdRef.markForCheck();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'] && user['email'].toLowerCase().indexOf(search) > -1);
    this.cdRef.markForCheck();
  }

  formatDateToYYYYMMDD(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  /** Called when calsoft-filter-list-popup emits filterChangeColumn for the lead filter accordion */
  onCampaignLeadFilterChange(searchTerm: string | undefined): void {
    if (!searchTerm) {
      this.clearLeadFilters();
      return;
    }

    this.applyLeadFilters(searchTerm);
    this.cdRef.markForCheck();
  }

  applyLeadFilters(searchTerm): void {
    let conditions: string[] = [];

    // Add owner/status/source conditions from filter-list-popup
    if (searchTerm) {
      conditions.push(searchTerm);
    }

    let searchStr = conditions.join(' AND ');


    this.leadFilterLoading = true;
    this.cdRef.markForCheck();

    this.productService.getLeadBySearch(searchStr, 0, 1, 'updatedDate,desc').subscribe({
      next: (res: any) => {
        this.leadFilterLoading = false;
        this.filteredLeadsCount = res.totalElements || res.content?.length || 0;
        this.isLeadFilterApplied = true;

        if (this.filteredLeadsCount > 0) {
          this.snackBar.open(`Filters applied successfully. Found ${this.filteredLeadsCount} matching leads.`, 'Close', {
            duration: 3000,
            panelClass: ['success']
          });
          searchStr = searchStr ? searchStr.split("'").join('') : '';
          this.campaignLeadFilterSearchTerm = searchStr;
        } else {
          this.snackBar.open(`No matching leads found for the selected filters.`, 'Close', {
            duration: 3000,
            panelClass: ['error']
          });
        }
        this.cdRef.markForCheck();
      },
      error: (err: any) => {
        this.leadFilterLoading = false;
        console.error('Error filtering leads:', err);
        this.snackBar.open('Error applying filters. Please try again.', 'Close', {
          duration: 3000,
          panelClass: ['error']
        });
        this.cdRef.markForCheck();
      }
    });
  }

  setupStatusFilter() {
    this.statusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatuses();
      });
  }

  filterStatuses() {
    if (!this.leadStatusList) return;
    let search = this.statusFilterControl.value;
    if (!search) {
      this.filteredStatusList = this.leadStatusList.slice();
      this.cdRef.markForCheck();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredStatusList = this.leadStatusList.filter(
      opt => opt.statusName && opt.statusName.toLowerCase().indexOf(search) > -1
    );
    this.cdRef.markForCheck();
  }

  setupSourceFilter() {
    this.sourceFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterSources();
      });
  }

  filterSources() {
    if (!this.leadSourceList) return;
    let search = this.sourceFilterControl.value;
    if (!search) {
      this.filteredSourceList = this.leadSourceList.slice();
      this.cdRef.markForCheck();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredSourceList = this.leadSourceList.filter(
      opt => opt.sourceName && opt.sourceName.toLowerCase().indexOf(search) > -1
    );
    this.cdRef.markForCheck();
  }

  clearLeadFilters(): void {
    this.templateForm.patchValue({
      defaultLeadOwner: [],
      leadStatus: [],
      leadSource: []
    });
    this.campaignLeadFilterSearchTerm = '';
    // Reset the filter-list-popup selections by re-creating the filterSelectObj
    this.campaignLeadFilterSelectObj = [
      { name: 'Owner', property: 'ownerEmail', type: 'multiSelect', position: 'firstValue', options: [], display: true },
      { name: 'Status Name', property: 'statusName', type: 'multiSelect', position: 'secondValue', options: [], display: true },
      { name: 'Source Name', property: 'sourceName', type: 'multiSelect', position: 'thirdValue', options: [], display: true },
      { name: 'Created Date', property: 'createdDate', type: 'date', position: 'sixthValue', display: true },
      { name: 'Updated Date', property: 'updatedDate', type: 'date', position: 'seventhValue', display: true }
    ];
    this.typeYFilterControl.setValue('');
    this.statusFilterControl.setValue('');
    this.sourceFilterControl.setValue('');
    this.isLeadFilterApplied = false;
    this.filteredLeadsCount = 0;
    this.cdRef.markForCheck();
  }

  onRecipientTypeChange(val: string): void {
    const contactGroupControl = this.templateForm.get('contactGroup');
    const defaultLeadOwnerControl = this.templateForm.get('defaultLeadOwner');

    if (val === 'contact') {
      if (!this.fromLeads && !this.fromSequence) {
        contactGroupControl?.setValidators([Validators.required]);
      } else {
        contactGroupControl?.clearValidators();
      }
      defaultLeadOwnerControl?.clearValidators();
      this.templateForm.get('leadSelectType')?.setValue('all');
      this.clearLeadFilters();
    } else {
      contactGroupControl?.clearValidators();
      // Lead Owner is now optional (multiselect in filter accordion)
      defaultLeadOwnerControl?.clearValidators();
    }
    contactGroupControl?.updateValueAndValidity();
    defaultLeadOwnerControl?.updateValueAndValidity();
    this.cdRef.markForCheck();
  }

  onLeadSelectTypeChange(val: string): void {
    const defaultLeadOwnerControl = this.templateForm.get('defaultLeadOwner');
    // Lead Owner is now optional (multiselect in filter accordion)
    defaultLeadOwnerControl?.clearValidators();
    defaultLeadOwnerControl?.updateValueAndValidity();
    if (val === 'all') {
      this.clearLeadFilters();
    }
    this.cdRef.markForCheck();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private _rawUrl: any = null;
  private _safeUrl: any = null;

  get safeHeaderMediaUrl(): any {
    const currentUrl = this.uploadedMediaUrl || this.originalHeaderMediaUrl;
    if (currentUrl !== this._rawUrl) {
      this._rawUrl = currentUrl;
      this._safeUrl = currentUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(currentUrl as any) : '';
    }
    return this._safeUrl;
  }

  getSafeUrl(url: any): any {
    if (!url) return '';
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
